import React from 'react';
import * as d3 from 'd3';


export default class LineGraph extends React.Component {
  componentDidUpdate(prevProps) {
    d3.selectAll('.step-one').remove();

    if (this.props.index !== -1 && this.props.index !== '') {
      d3.selectAll('.pre-msg').remove();
      this.createline();              //** line chart
      this.createVerticalLine();      //** indicate month
      this.createDots();              //** data point
      this.createAxis();              //** Axis
      this.handleEventInteraction();  //** hover event
    };

    if (prevProps.value !== this.props.value) {  //** this part to check if visualization.js update its
      d3.select('#data-line').attr('d', '');
      d3.selectAll('.vertical-line').attr('y1', '470');
      d3.selectAll('circle').remove();
    }
  }

  dataMinMax() {
    const data = this.props.data;
    let dataPoint = [];
    //** loop to load all data across all years, in order to fix the y-axis when click different year
    for (let i = 0; i < data.length; i++) { //** original: "for (let i in data) {...}" */   // modified for ios 8
      dataPoint = dataPoint.concat(data[i]['Month']);
    }

    const MinMax = [d3.min(dataPoint), d3.max(dataPoint)];
    return MinMax;
  }

  createScale() {
    const width = this.props.size[0];
    const height = this.props.size[1];
    const padding = 30;
    const Max = this.dataMinMax()[1];

    const xScale = d3.scalePoint()
      .domain([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
      .range([padding, width - padding])
      .padding([padding]);

    const yScale = d3.scaleLinear()
      .domain([0, Max])
      .range([height - padding , padding]);

    return [xScale, yScale];
  }

  createline() {
    const index = this.props.index;
    const data = this.props.data[index];
    let svg = this.node;
    const yScale = this.createScale()[1];
    const xScale = this.createScale()[0];

    let dataPointIndex = [];

    //** function for create "line chart"
    var line = d3.line()
      .defined((d) => {
        if (!isNaN(d[1])) {
          return d;
        }
      })
      .x((d) => { return xScale(d[0] + 1); })
      .y((d) => { return yScale(d[1]); })
      .curve(d3.curveMonotoneX);

    data['Month'].map((d, i) => { return dataPointIndex.push([i, d]) });

    d3.select(svg)
      .select('#data-line')
      .transition()
      .duration(1000)
      .attr('d',  line(dataPointIndex))
      .attr('fill', 'none')
      .attr("stroke", "gray");
  }

  createVerticalLine() {
    const yScale = this.createScale()[1];
    const xScale = this.createScale()[0];
    const index = this.props.index;
    const svg = this.node;
    const data = this.props.data[index];

    d3.select(svg)
      .selectAll('line')
      .data(data.Month)
      .enter()
      .append('line');

    d3.select(svg)
      .selectAll('line')
      .transition()
      .duration(1000)
      .attr('class', 'vertical-line')
      .attr('x1', (d, i) => {
        return xScale(i + 1);
      })
      .attr('x2', (d, i) => {
        return xScale(i + 1);
      })
      .attr('y1', (d, i) => {
        if (isNaN(d)) {
          return yScale(0);
        } else {
          return yScale(d);
        }
      })
      .attr('y2', () => {
        return yScale(0);
      });
  }

  createDots() {
    const index = this.props.index;
    const data = this.props.data[index];
    const svg = this.node;
    const yScale = this.createScale()[1];
    const xScale = this.createScale()[0];

    d3.select(svg)
      .selectAll('circle')
      .data(data.Month)
      .enter()
      .append('circle');

    d3.select(svg)
      .selectAll("circle")
      .transition()
      .duration(1000)
      .attr('class', 'data-point')
      .attr("cx", (d, i) => xScale(i + 1))
      .attr("cy", (d) => {
        if (isNaN(d)) {
          return yScale(0);
        } else {
          return yScale(d);
        }
      })
      .attr('r', d => {
       if (isNaN(d)) {
          return 0;
        } else {
          return 9;
        }
      })
      .attr('opacity', (d) => {
        if (isNaN(d)) {
          return '0';
        } else {
          return '1';
        }
      })
      .attr('fill', '#21624F');
  }

  createAxis() {
    d3.selectAll('.axis').remove();
    const height = this.props.size[1];
    const width = this.props.size[0];
    const padding = 30;
    const svg = d3.select(this.node);
    const yScale = this.createScale()[1];
    const xScale = this.createScale()[0];

    const xAxis = d3.axisBottom()
      .scale(xScale)
      .ticks(12);

    const yAxis = d3.axisLeft()
      .scale(yScale)
      .ticks(15);

    //** plot x-axis
    svg.append('g')
      .attr('class', 'axis axisX')
      .attr('transform', 'translate(0,' + (height - padding) + ')')
      .call(xAxis);

    //** plot y-axis
    svg.append('g')
      .attr('class', 'axis axisY')
      .attr('transform', 'translate(' + (padding) + ', 0)')
      .call(yAxis);

    //** create horizontal line for indicating y-axis
    const ylabel = svg.selectAll('.axisY .tick');
    let data = ylabel['_groups']['0'];
    for (let i = 0; i < data.length; i++) {
      let d = data[i];
      let h = d['attributes']['transform']['nodeValue'];

      svg.append('g')
       .append('line')
       .attr('transform', h)
       .attr('x2', padding)
       .attr('x1', width - padding)
       .attr('class', 'horizontal-line')
       .call(yAxis);
    };

    //** y-axis label
    svg.select('.axisY')
      .append('text')
      .attr('class', 'unit')
      .attr('fill', 'currentColor')
      .text(this.props.unit);
  }

  handleEventInteraction() {
    let value = document.querySelector('#data-value');
    let info = document.querySelector('#date-info');

      d3.selectAll('circle')
      .on('mouseover', (d, i) => {
        value.innerHTML = d;
        info.innerHTML = this.props.year + ' 年 ' + (i + 1) + ' 月';
        d3.event.target.setAttribute('fill', '#FD5523');
      })
      .on('mouseleave', (d, i) => {
        value.innerHTML = '--';
        info.innerHTML = '-- 年 -- 月 (請點選圖中資料點)';
         d3.event.target.setAttribute('fill', '#21624F');
      });
  }

  typeName(type) {
    let type_name = '';
    switch (type) {
      case 'vegitables':
      type_name = '蔬菜';
      return type_name;

      case 'fruits':
      type_name = '水果';
      return type_name;

      case 'grains':
      type_name = '雜糧';
      return type_name;

      case 'special':
      type_name = '特作';
      return type_name;

      case 'flowers':
      type_name = '花卉';
      return type_name;

      default:
        break;
    }
  }

  render() {
    return(
      <div id="line-graph">
        <svg ref={node => this.node = node} viewBox="-45 -20 550 550" xmlns="http://www.w3.org/2000/svg">
          <path id="data-line"></path>

          <foreignObject className="pre-msg" x="120" y="150" width="300" height="300">
            <div xmlns="http://www.w3.org/1999/xhtml">
              <p>請選擇欲查詢的{this.typeName(this.props.type)}</p>
              <ul>
                <li className="step-one">選擇查詢名稱</li>
                <li className="step-two">選擇資料年份</li>
              </ul>
            </div>
          </foreignObject>
        </svg>

        <div id="tooltip">
          <p>品名: <span id="item-name">{this.props.itemChsName}</span></p>
          <p>日期: <span id="date-info">-- 年 -- 月 (請點選圖中資料點)</span></p>
          <p>{this.props.dataType}:<span id="data-value">--</span>{this.props.unit}</p>
        </div>
      </div>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/containers/line_graph.js